/**
 * Changes made:
 * - 2026-02-16: Created home page reviews display showing up to 7 approved seller reviews
 * - 2026-02-18: Matched heading two-tone style to HowItWorks (text-heading + text-primary), reduced padding and heading margin
 */

import React from 'react';
import { Star } from 'lucide-react';
import { useApprovedReviews } from '@/hooks/useApprovedReviews';

export const SellerReviewsDisplay = () => {
  const { data: reviews, isLoading } = useApprovedReviews();

  if (isLoading || !reviews || reviews.length === 0) return null;

  return (
    <section className="w-full py-6 md:py-8 px-4 md:px-8 bg-background">
      <h2 className="text-5xl font-heebo font-bold text-center mb-10">
        <span className="text-heading">Opinie</span> <span className="text-primary">sprzedających</span>
      </h2>
      <div className="max-w-6xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 md:gap-6">
        {reviews.map((review) => (
          <div
            key={review.id}
            className="rounded-xl border border-border bg-card p-5 flex flex-col gap-3 shadow-sm"
          >
            {/* Stars */}
            <div className="flex gap-0.5">
              {[1, 2, 3, 4, 5].map((star) => (
                <Star
                  key={star}
                  className={`h-4 w-4 ${
                    star <= review.rating ? 'fill-yellow-400 text-yellow-400' : 'text-muted-foreground/30'
                  }`}
                />
              ))}
            </div>

            {/* Review text */}
            <p className="text-sm text-muted-foreground line-clamp-4 flex-1">
              "{review.review_text}"
            </p>

            {/* Seller name & car */}
            <div className="pt-2 border-t border-border">
              <p className="font-semibold text-sm text-foreground">{review.seller_name}</p>
              <p className="text-xs text-muted-foreground">{review.car_title}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};
